<div class="keyword-chip" [class.transparent]="transparent()">
  <div class="keyword-content" (click)="toggleSynonyms($event)">
    {{ keyword().keyword }}
    @if (filterInput() && filterInput() !== QueryBlockFilter.None) {
      [{{ filterInput() }}]
    }
    <div class="keyword-extended" [class.visible]="showSynonyms()">
      <div class="keyword-synonyms">
        @for (synonym of keyword().synonyms; track $index) {
          <span>OR {{ synonym }}</span>
        }
      </div>
      <div class="keyword-extended--actions">
        <mat-form-field class="full-width" (click)="$event.stopPropagation()">
          <mat-label>Filters</mat-label>
          <mat-select
            [value]="filterInput()"
            (valueChange)="filterChange.emit($event)">
            @for (filter of filterList; track $index) {
              <mat-option [value]="filter">{{ filter }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <button mat-button color="warn" (click)="$event.stopPropagation(); deleteKeyword.emit()">
          <mat-icon>close</mat-icon>
          Remove
        </button>
      </div>
    </div>

  </div>
</div>

